import { render, staticRenderFns } from "./lawsuit-case.vue?vue&type=template&id=efa68d4c&scoped=true"
import script from "./lawsuit-case.vue?vue&type=script&lang=ts"
export * from "./lawsuit-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa68d4c",
  null
  
)

export default component.exports